<template>
  <div id="app">
    <router-view />
    <div id="body-bottom-container"></div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { ElMessageBox } from 'element-plus'

defineOptions({
  name: 'App'
})

const beforeUnloadHandler = ref(null)
const keydownHandler = ref(null)

function showRefreshConfirm() {
  ElMessageBox.confirm('你所做的更改可能未保存', '重新加载站点?', {
    confirmButtonText: '重新加载',
    cancelButtonText: '取消',
    type: 'warning',
    closeOnClickModal: false,
    closeOnPressEscape: false
  }).then(() => {
    window.location.reload()
  }).catch(() => {})
}

function handleKeyboardRefresh() {
  keydownHandler.value = (event) => {
    const isF5 = event.key === 'F5' || event.keyCode === 116
    const isCtrlR = (event.ctrlKey || event.metaKey) && (event.key === 'r' || event.key === 'R' || event.keyCode === 82)
    const isCtrlShiftR = (event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'r' || event.key === 'R' || event.keyCode === 82)

    if (isF5 || isCtrlR || isCtrlShiftR) {
      event.preventDefault()
      event.stopPropagation()
      showRefreshConfirm()
    }
  }

  window.addEventListener('keydown', keydownHandler.value, true)
}

function handleBeforeUnload() {
  beforeUnloadHandler.value = (event) => {
    event.preventDefault()
    event.returnValue = '你所做的更改可能未保存'
    return '你所做的更改可能未保存'
  }

  window.addEventListener('beforeunload', beforeUnloadHandler.value)
}

onMounted(() => {
  handleKeyboardRefresh()
  handleBeforeUnload()
})

onBeforeUnmount(() => {
  if (beforeUnloadHandler.value) {
    window.removeEventListener('beforeunload', beforeUnloadHandler.value)
  }

  if (keydownHandler.value) {
    window.removeEventListener('keydown', keydownHandler.value, true)
  }
})
</script>

<style lang="scss">
@import '@/assets/css/style.scss';

html,
body,
#app {
  min-height: 100%;
}

body {
  margin: 0;
}
</style>
